import { Button, Modal, Radio } from '@material-ui/core';
import { Input } from 'rsuite';
import { Accordion, Container } from 'semantic-ui-react';
import styled, { css } from 'styled-components';

export const WrapperContainer = styled(Container)`
  padding-top: 8rem;
  width: 100%;
`;

export const WrapperDiv = styled.div`
  margin: 1rem 0;
`;

export const HeaderWrapper = styled.div`
  margin: 1rem 0;
  color: #5c5d5d;
  font-size: 18px;
`;

export const HeaderWrapperBold = styled.div`
  margin: 1rem 0;
  color: #5c5d5d;
  font-size: 18px;
  font-weight: bold;
`;

// help section styled components

export const HelpWrapperContainer = styled(Container)`
  margin-top: 8rem;
  margin-bottom: 8rem;
`;

export const StyledAccordion = styled(Accordion)`
  > .title {
    font-weight: bold;
  }
`;

export const ScrollingHelpContainer = styled.div`
  color: #5c5d5d;
  display: block;
  height: 200vh;
  min-height: 600px;
  scroll-behavior: smooth;
`;

export const AccordionContainer = styled.div`
  position: sticky;
  top: 5%;
  overflow: auto;
`;

export const SectionWrapper = styled.section`
  margin-bottom: 2rem;
  scroll-margin-top: 5rem;
`;

export const SectionHeadingWrapper = styled.div`
  color: #000;
  font-weight: bold;
  margin: 1rem 0;
`;

export const HelpSectionHeader = styled.div`
  font-size: 26px;
  margin-bottom: 3rem;
`;

export const HelpAnchor = styled.a`
  color: #027680;
  text-decoration: underline;
  :hover {
    color: #027680;
  }
`;

export const HelpContactUsWrapper = styled.div`
  margin-top: 100px;
`;

/**
 *   _____                      _
 *  / ____|                    (_)
 * | |  __  ___ _ __   ___ _ __ _  ___ ___
 * | | |_ |/ _ \ '_ \ / _ \ '__| |/ __/ __|
 * | |__| |  __/ | | |  __/ |  | | (__\__ \
 *  \_____|\___|_| |_|\___|_|  |_|\___|___/
 */

export const Link = styled.a`
  color: #027680;
  font-weight: bold;
  text-decoration: underline;
`;

export const Wrapper = styled.div`
  min-width: 600px;
  max-width: 1000px;
`;

export const ViewContainer = styled.div`
  padding-top: 8rem;
  max-width: 1200px;
  min-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

export const ImageWrapper = styled.div`
  margin-top: ${(props) => props.marginTop ? props.marginTop : '200px' };
  display: flex;
  justify-content: flex-end;
`;

export const ButtonWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-width: 400px;
`;

const modalBase = css`
  /* Sit on top of the page content */
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.65);
`;

export const MUIModal = styled(Modal)`
  ${modalBase}
  backdrop-filter: blur(4px);
`;

export const WhiteModal = styled(Modal)`
  ${modalBase}
  background-color: white;
`;

export const BalloonTooltip = styled.span`
  margin-left: 6px;
`;

/**
 *  _______        _
 * |__   __|      | |
 *    | | _____  _| |_
 *    | |/ _ \ \/ / __|
 *    | |  __/>  <| |_
 *    |_|\___/_/\_\\__|
 */

export const textBase = css`
  font-family: 'Lato';
  color: #5c5d5d;
`;

export const HeaderText = styled.div`
  ${textBase}

  font-size: 18px;
  line-height: 1.56;
  padding-bottom: 20px;
`;

export const BoldedLabel = styled.p`
  ${textBase}
  font-size: 14px;
  font-weight: ${(props) => props.bold ? 'bold' : 'normal'};
  line-height: 1.5;
`;

/**
 * _    _                 _____                   _
 * | |  | |               |_   _|                 | |
 * | |  | |___  ___ _ __    | |  _ __  _ __  _   _| |_
 * | |  | / __|/ _ \ '__|   | | | '_ \| '_ \| | | | __|
 * | |__| \__ \  __/ |     _| |_| | | | |_) | |_| | |_
 *  \____/|___/\___|_|    |_____|_| |_| .__/ \__,_|\__|
 *                                    | |
 *                                    |_|
 */

export const StyledInput = styled(Input)`
  border-radius: 5px;
  border-color: rgb(207, 207, 207);

  width: ${(props) => props.width ? props.width : '400px' };
  height: 36px;
`;

export const InputTextFieldLabel = styled.div`
  ${textBase}
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.5;
  color: #7f8fa4;
`;

export const BlackRadio = styled(Radio)`
  &&& {
    color: #1b1c1d;
  }
`;

export const GreenButton = styled(Button)`
  &&& {
    width: 140px;
    height: 36px;
    background-color: rgba(83, 156, 162, 0.1);

    text-transform: none;
    font-family: 'Lato';
    font-size: 14px;
    font-weight: bold;
    line-height: 1.5;
    color: #027680;
  }
`;

/**
 *  ______
 * |  ____|
 * | |__ ___  _ __ _ __ ___  ___
 * |  __/ _ \| '__| '_ ` _ \/ __|
 * | | | (_) | |  | | | | | \__ \
 * |_|  \___/|_|  |_| |_| |_|___/
 */

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const SideBySideInputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 400px;
`;

/**
 *  __  __           _       _
 * |  \/  |         | |     | |
 * | \  / | ___   __| | __ _| |
 * | |\/| |/ _ \ / _` |/ _` | |
 * | |  | | (_) | (_| | (_| | |
 * |_|  |_|\___/ \__,_|\__,_|_|
 */

export const DarkModal = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
`;
